import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=2284681c&scoped=true&"
import script from "./Plan.vue?vue&type=script&lang=js&"
export * from "./Plan.vue?vue&type=script&lang=js&"
import style0 from "./Plan.vue?vue&type=style&index=0&id=2284681c&prod&lang=scss&"
import style1 from "./Plan.vue?vue&type=style&index=1&id=2284681c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2284681c",
  null
  
)

export default component.exports